import { LoginPage } from "@features/login/LoginPage.tsx";
import { LoginMandatorRoute } from "@features/login/LoginMandatorRoute.tsx";
import { SignupPage } from "@features/login/signup/SignupPage.tsx";
import { SignupConfirmationPage } from "@features/login/signup/SignupConfirmationPage.tsx";
import { EmailConfirmationPage } from "@features/login/confirm/EmailConfirmationPage.tsx";
import { ResetPasswordPage } from "@features/login/reset/ResetPasswordPage.tsx";
import { AssignPasswordPage } from "@features/login/reset/AssignPasswordPage.tsx";
import { LogoutWithRedirect } from "@features/login/logout/LogoutWithRedirect.tsx";
import { EndImpersonation } from "@features/login/impersonate/EndImpersonation.tsx";
import React from "react";
import { RouteWithRedirect } from "../routes.tsx";

export default [
  {
    path: "login/:mandatorSegment",
    element: (
      <RouteWithRedirect type="login" onlyOnProduction>
        <LoginMandatorRoute />
      </RouteWithRedirect>
    ),
  },
  {
    path: "login",
    element: (
      <RouteWithRedirect type="login" onlyOnProduction>
        <LoginPage />
      </RouteWithRedirect>
    ),
  },
  {
    path: "signup",
    element: (
      <RouteWithRedirect type="signup" onlyOnProduction>
        <SignupPage />
      </RouteWithRedirect>
    ),
  },
  {
    path: "signup/confirmationRegistration",
    element: <SignupConfirmationPage />,
  },
  {
    path: "confirmation/email",
    element: (
      <RouteWithRedirect type="emailConfirmation" onlyOnProduction>
        <EmailConfirmationPage />
      </RouteWithRedirect>
    ),
  },
  {
    path: "reset/password",
    element: <ResetPasswordPage />,
  },
  {
    path: "reset/assign-password",
    element: <AssignPasswordPage />,
  },
  {
    path: "logout",
    element: (
      <RouteWithRedirect type="logout" onlyOnProduction>
        <LogoutWithRedirect />
      </RouteWithRedirect>
    ),
  },
  {
    path: "logout/impersonate",
    element: <EndImpersonation />,
  },
];
